<template>
    <v-app>
        <v-main>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-title>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                            />
                        </v-card-title>
                        <v-data-table
                            class="elevation-1"
                            loading-text="Loading... Please wait"
                            multi-sort
                            :loading="loading"
                            :headers="headers"
                            :items="pages"
                            :items-per-page="10"
                            :footer-props="{
                                showFirstLastPage: true,
                                firstIcon: 'mdi-arrow-collapse-left',
                                lastIcon: 'mdi-arrow-collapse-right',
                                prevIcon: 'mdi-minus',
                                nextIcon: 'mdi-plus'
                            }"
                            :search="search"
                        >
                            <template v-slot:item.created_at="{ item }">
                                {{ $date(item.created_at).format('DD/MM/YYYY') }}
                            </template>
                            <template v-slot:item.last_submission="{ item }">
                                {{ item.last_submission === null ? 'None' : $date(item.last_submission).fromNow() }}
                            </template>
                            <template v-slot:item.last_post="{ item }">
                                {{ item.last_post === null ? 'None' : $date(item.last_post).fromNow() }}
                            </template>
                            <template v-slot:item.archived="{ item }">
                                <v-icon
                                    v-if="item.archived"
                                    small
                                    class="mr-2"
                                >
                                    mdi-check
                                </v-icon>
                                <v-icon
                                    v-else
                                    small
                                    class="mr-2"
                                >
                                    mdi-plus mdi-rotate-45
                                </v-icon>
                            </template>
                            <template v-slot:item.linked_to_facebook="{ item }">
                                <v-icon
                                    v-if="item.linked_to_facebook"
                                    small
                                    class="mr-2"
                                >
                                    mdi-check
                                </v-icon>
                                <v-icon
                                    v-else
                                    small
                                    class="mr-2"
                                >
                                    mdi-plus mdi-rotate-45
                                </v-icon>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <a
                                    :href="'/developer/pages/' + item.url_prefix"
                                    style="text-decoration: none; color: inherit;"
                                >
                                    <v-icon
                                        small
                                        class="mr-2"
                                    >
                                        mdi-eye
                                    </v-icon>
                                </a>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-main>
    </v-app>
</template>
<script>
export default {
    data() {
        return {
            headers: [
                {
                    text: 'Name',
                    value: 'name',
                },
                {
                    text: 'Prefix',
                    value: 'url_prefix',
                },
                {
                    text: 'Submissions Today',
                    value: 'submissions_today',
                    filterable: false,
                },
                {
                    text: 'Last Submission',
                    value: 'last_submission',
                    filterable: false,
                },
                {
                    text: 'Posts Today',
                    value: 'posts_today',
                    filterable: false,
                },
                {
                    text: 'Post Queue Size',
                    value: 'post_queue_size',
                    filterable: false,
                },
                {
                    text: 'Last Post',
                    value: 'last_post',
                    filterable: false,
                },
                {
                    text: 'Linked to Facebook',
                    value: 'linked_to_facebook',
                    filterable: false,
                    align: 'center',
                },
                {
                    text: 'Archived',
                    value: 'archived',
                    filterable: false,
                    align: 'center',
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    filterable: false,
                    align: 'center',
                },
            ],
            pages: [],
            loading: true,
            search: '',
        };
    },

    created() {
        this.fetchPages();
    },

    methods: {
        fetchPages() {
            this.loading = true;
            axios
                .get("/api/developer/pages")
                .then(response => {
                    this.pages = response.data;
                    this.loading = false;
                });
        },
    },
};
</script>
